export default __webpack_public_path__ + "static/media/icon_done.17866cc7.svg";